import ApiClient from "../helpers/ApiClient";

const novoProcessoBpo = (data) =>
  ApiClient.apiClientDef.post(`timeline/bpo`, data);

const getProcessosBpo = (data) =>
  ApiClient.apiClientDef.get(`timeline/bpo`, data);

const getProcessoBpo = (uid) =>
  ApiClient.apiClientDef.get(`timeline/bpo/${uid}`);

const salvaProcessoBpo = (uid, data) =>
  ApiClient.apiClientDef.put(`timeline/bpo/${uid}`, data);

const deletarProcessoBpo = (uid) =>
  ApiClient.apiClientDef.delete(`timeline/bpo/${uid}`);

const finalizarProcessoBpo = (uid, data) =>
  ApiClient.apiClientDef.post(`timeline/bpo/${uid}/finalizar`, data);

const getProcessosAutonomo = () =>
  ApiClient.apiClientDef.get(`timeline/autonomo`);

const postProcessosAutonomo = (data) =>
  ApiClient.apiClientDef.post(`timeline/autonomo`, data);

const getProcessoAutonomo = (uid) =>
  ApiClient.apiClientDef.get(`timeline/autonomo/${uid}`);

const deleteProcessoAutonomo = (uid) =>
  ApiClient.apiClientDef.delete(`timeline/autonomo/${uid}`);

const putProcessoAutonomo = (uid, data) =>
  ApiClient.apiClientDef.put(`timeline/autonomo/${uid}`, data);

const finalizarProcessoAutonomo = (uid, data) =>
  ApiClient.apiClientDef.post(`timeline/autonomo/${uid}/finalizar`, data);

const getProcessosMei = () => ApiClient.apiClientDef.get(`timeline/mei`);

const postProcessosMei = (data) =>
  ApiClient.apiClientDef.post(`timeline/mei`, data);

const deleteProcessoMei = (uid) =>
  ApiClient.apiClientDef.delete(`timeline/mei/${uid}`);

const getProcessoMei = (uid) =>
  ApiClient.apiClientDef.get(`timeline/mei/${uid}`);

const putProcessoMei = (uid, data) =>
  ApiClient.apiClientDef.put(`timeline/mei/${uid}`, data);

const finalizarProcessoMei = (uid, data) =>
  ApiClient.apiClientDef.post(`timeline/mei/${uid}/finalizar`, data);

const getProcessosMigracao = () =>
  ApiClient.apiClientDef.get(`timeline/migracao`);

const getProcessoMigracao = (uid) =>
  ApiClient.apiClientDef.get(`timeline/migracao/${uid}`);

const postProcessosMigracao = (data) =>
  ApiClient.apiClientDef.post(`timeline/migracao`, data);

const deleteProcessoMigracao = (uid) =>
  ApiClient.apiClientDef.delete(`timeline/migracao/${uid}`);

const atualizarEtapaMigracao = (uid, etapa, data) =>
  ApiClient.apiClientDef.put(`timeline/migracao/${uid}/etapa/${etapa}`, data);

const finalizarProcessoMigracao = (uid, data) =>
  ApiClient.apiClientDef.post(`timeline/migracao/${uid}/finalizar`, data);

const adicionarUsuarioMigracao = (data, uid) =>
  ApiClient.apiClientDef.post(`timeline/migracao/usuarios/${uid}`, data);

const getUsuariosMigracao = (uid) =>
  ApiClient.apiClientDef.get(`timeline/migracao/usuarios/${uid}`);

const getAdministradoresMigracao = (uid) =>
  ApiClient.apiClientDef.get(`timeline/migracao/administradores/${uid}`);

const getUsuarios = () =>
  ApiClient.apiClientDef.get(`timeline/migracao/usuarios`);

const getAdministradores = () =>
  ApiClient.apiClientDef.get(`timeline/migracao/administradores`);

const vincularUsuarios = (data, uid) =>
  ApiClient.apiClientDef.put(
    `timeline/migracao/usuarios/${uid}/vincular`,
    data
  );

const atualizarStatusUsuario = (data, uid, uid_colaborador) =>
  ApiClient.apiClientDef.put(
    `timeline/migracao/usuarios/${uid}/${uid_colaborador}`,
    data
  );

const fastProcessoMigracao = (data) =>
  ApiClient.apiClientDef.post(`timeline/migracao/fast`, data);

const verificarSocioMigracao = (uid, data) =>
  ApiClient.apiClientDef.post(
    `timeline/migracao/${uid}/etapa/2/verificar`,
    data
  );

const TimelineApiClient = {
  novoProcessoBpo,
  getProcessosBpo,
  getProcessoBpo,
  salvaProcessoBpo,
  deletarProcessoBpo,
  finalizarProcessoBpo,
  getProcessosAutonomo,
  postProcessosAutonomo,
  getProcessoAutonomo,
  deleteProcessoAutonomo,
  putProcessoAutonomo,
  finalizarProcessoAutonomo,
  getProcessosMei,
  postProcessosMei,
  deleteProcessoMei,
  getProcessoMei,
  putProcessoMei,
  finalizarProcessoMei,
  getProcessosMigracao,
  getProcessoMigracao,
  postProcessosMigracao,
  deleteProcessoMigracao,
  atualizarEtapaMigracao,
  finalizarProcessoMigracao,
  adicionarUsuarioMigracao,
  getUsuariosMigracao,
  getUsuarios,
  getAdministradores,
  vincularUsuarios,
  getAdministradoresMigracao,
  atualizarStatusUsuario,
  fastProcessoMigracao,
  verificarSocioMigracao,
};
export default TimelineApiClient;
